<!--
 * @Author: xing.huang
 * @Date: 2021-02-01 11:45:53
 * @LastEditTime: 2021-02-01 15:03:35
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\FactoryModel\ReViewDialog.vue
 * @
-->
<template>
	<div id="importOrderDialog">
		<el-dialog  title="预览布局图"  :visible.sync="isShowDialog" :width="W?'60%':'70%'" center :close-on-click-modal="false" @close="cancelView">
            <div>
                <div v-for="(pItem,index0) in reViewList" :key="index0" >
                    <div v-for="(item,index) in pItem.cargoColumnNumberDtos" :key="index" >
                        <div  class="column-warp">
                            <div  v-for="(sub,subIndex) in item.positionLayerDtos" :key="subIndex" class="column">
                                <div v-for="(lastItem,lastIndex) in sub.positionColumnDtos" :key="lastIndex" class="item">
                                    <span >{{lastItem.positionName}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			<div style="text-align: center;">
                <el-button  @click="cancelView">取 消</el-button>
            </div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'ReViewDialog',
	props: {
        showReView: Boolean,
        id:Number,
	},
	data() {
        let that = this
		return {
            
            W:true,
            isShowDialog: false,
            
            reViewList:[],
            cargoColumnNumberList:[],
            positionLayerList:[],
            positionColumnList:[],
            list:[],
            addForm:{},
        }
    },
    mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        this.W = w>=1900?true:false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            this.W = w>=1900?true:false
        }
    },
    methods:{
        
        cancelView(){
            
            this.list = []
            this.submitList = []
            this.$parent.showReView = false
        },
        async loadData(){
            let {data, code, msg, message} = await this.$RequestUtil.getAsync({url: '/api/factoryModel/positionLayout',type: 'sync', params: {id:this.id},})
            if (code == 0) {
                log(data)
                this.reViewList = data
                this.createStock()
            } else {
                this.$message.error(msg || message)
            }
        },
        getNumbersList(start,end,type){
            //type 0 - 连续数 1-奇数 2-偶数
            let list = []
            start=Number(start)
            end = Number(end)
            for(let i = start;i<=end;i++){
                
                if(type==0){
                    list.push(i)
                }else if(type==1){
                    if(i%2==1){
                        list.push(i)
                    }
                }else{
                    if(i%2==0){
                        list.push(i)
                    }
                }
            }
            return list
        },

        createStock(){
            this.reViewList.forEach(r=>{
                r.cargoColumnNumberDtos.forEach(a=>{  //货列号
                    a.positionLayerDtos.sort((item1,item2)=>item2.positionLayer - item1.positionLayer)
                    a.positionLayerDtos.forEach(l=>{  //层
                        l.positionColumnDtos.forEach(c=>{  //列
                            c.positionName = r.areaCode+'-'+a.cargoColumnNumber+'-'+c.positionColumn+'-'+l.positionLayer
                        })
                    })
                })
            })    
        },
    },
    watch: {
		"showReView": async function (newVal, oldVal) {
            this.isShowDialog = this.showReView;
            if(newVal){
                log(this.id)
                await this.loadData()
            }
		},
	},
}
</script>
<style scoped>
.column-warp{
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
}
.column{
    display: flex;
    
    border-right: 1px solid #ccc;
}
.column .item{
    flex: 1;
    height: 40px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    text-align: center;
    line-height: 40px;
    
}
.title {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display: inline-block;
    text-align: right;
    width: 70px;
}

.value {
    display: inline-block
}
</style>




// WEBPACK FOOTER //
// src/views/FactoryModel/ReViewDialog.vue